var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.4183H4C3.46957 4.4183 2.96086 4.65105 2.58579 5.06535C2.21071 5.47965 2 6.04155 2 6.62745V22.0915C2 22.6774 2.21071 23.2393 2.58579 23.6536C2.96086 24.0679 3.46957 24.3007 4 24.3007H18C18.5304 24.3007 19.0391 24.0679 19.4142 23.6536C19.7893 23.2393 20 22.6774 20 22.0915V14.3595",
    stroke: "#21263C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.76143C18.8978 2.322 19.4374 2.07513 20 2.07513C20.5626 2.07513 21.1022 2.322 21.5 2.76143C21.8978 3.20086 22.1213 3.79685 22.1213 4.41829C22.1213 5.03974 21.8978 5.63573 21.5 6.07515L12 16.5686L8 17.6732L9 13.2549L18.5 2.76143Z",
    stroke: "#21263C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.53a4d35224f24d9c51dd8943352a1542.svg";
export { ForwardRef as ReactComponent };